/*
 * Vehicle steps, drawing only: renders the view model from seatfit-vehicle-steps-model.js into the
 * block body. Every control is a <button type="button"> or the Year <select> with NO name and NO
 * form attribute, so nothing here can join Shrine's option radio groups or the product form.
 * Clicks are handled by the controller through data-sf-act; focus survives a redraw via data-sf-focus.
 */
(function () {
  'use strict';
  if (window.SeatFitStepsView) return;
  var SVG = 'http://www.w3.org/2000/svg';

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    // referrerpolicy must be set before src so the placeholder images never send our page URL.
    if (attrs && attrs.referrerpolicy) el.setAttribute('referrerpolicy', attrs.referrerpolicy);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false || k === 'referrerpolicy') return;
      if (k === 'text') el.textContent = v;
      else if (k === 'html') el.innerHTML = v; // merchant rich text only (badge setting)
      else el.setAttribute(k, v === true ? '' : String(v));
    });
    (kids || []).forEach(function (c) {
      if (c != null && c !== '') el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }

  function svg(cls, viewBox, paths) {
    var el = document.createElementNS(SVG, 'svg');
    el.setAttribute('class', cls);
    el.setAttribute('viewBox', viewBox);
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('focusable', 'false');
    paths.forEach(function (p) {
      var node = document.createElementNS(SVG, p[0]);
      Object.keys(p[1]).forEach(function (k) { node.setAttribute(k, p[1][k]); });
      el.appendChild(node);
    });
    return el;
  }

  function chevron() {
    return svg('sf-step__chev', '0 0 12 8', [['path', { d: 'M1 6.5 6 1.5l5 5', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.4' }]]);
  }

  function checkMark() {
    return svg('sf-card__check', '0 0 20 20', [
      ['circle', { cx: '10', cy: '10', r: '10', fill: '#000', 'fill-opacity': '0.8' }],
      ['path', { d: 'M5 10.5l3 3 7-7', fill: 'none', stroke: '#fff', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }]
    ]);
  }

  // sf-step--empty: the reference layout shows no chevron on an open, unanswered step (CSS hides it), while a
  // folded one keeps it so it can be reopened; the toggle only flips is-open, so CSS decides.
  function stepClass(row, missingKey, extra) {
    return 'sf-step' + (row.open ? ' is-open' : '') + (row.value ? '' : ' sf-step--empty') +
      (missingKey === row.key ? ' sf-is-missing' : '') + (extra || '');
  }

  function head(row, hint) {
    return h('button', { type: 'button', class: 'sf-step__head', 'data-sf-act': 'toggle', 'data-sf-key': row.key,
      'aria-expanded': String(!!row.open), 'data-sf-focus': 'toggle:' + row.key }, [
      h('span', { class: 'sf-step__title', text: row.num + '. ' + row.name }),
      h('span', { class: 'sf-step__value', text: row.value || hint }),
      chevron()
    ]);
  }

  // A hint (Generation step: the seat type that tells two overlapping year ranges apart) goes on a second line.
  function pill(act, key, o, extra) {
    var attrs = { type: 'button', class: 'sf-opt' + (o.hint ? ' sf-opt--hint' : '') + (o.selected ? ' is-selected' : ''),
      'data-sf-act': act, 'data-sf-key': key, 'data-sf-value': o.value, 'aria-pressed': String(!!o.selected),
      'data-sf-focus': act + ':' + key + ':' + o.value, text: o.hint ? null : o.label };
    var kids = o.hint ? [h('span', { class: 'sf-opt__label', text: o.label }), h('span', { class: 'sf-opt__hint', text: o.hint })] : null;
    return h('button', Object.assign(attrs, extra || {}), kids);
  }

  // Picture card (Cab drawings, Seat Set): the reference layout's 8px frame around a grey picture box (ringed
  // when chosen), the check in the frame corner and the label under it. No picture -> an empty grey box.
  // Eager + high priority: the cards appear right after a tap, in view, and a lazy (Low) request queued
  // behind the page's posters and videos for 5-25 s on phones.
  function card(act, key, o, s) {
    var pic = o.img ? h('img', { referrerpolicy: 'no-referrer', loading: 'eager', fetchpriority: 'high', alt: '',
      width: 148, height: 97, src: o.img })
      : h('span', { class: 'sf-card__ph' });
    var badge = o.badge ? h('span', { class: 'sf-badge', html: o.badge }) : null;
    return h('button', { type: 'button', class: 'sf-card' + (o.selected ? ' is-selected' : ''), 'data-sf-act': act,
      'data-sf-key': key, 'data-sf-value': o.value, 'aria-pressed': String(!!o.selected), 'data-sf-focus': act + ':' + key + ':' + o.value }, [
      h('span', { class: 'sf-card__img' }, [pic, o.selected ? checkMark() : null]),
      o.selected && s.selected_label ? h('span', { class: 'visually-hidden', text: s.selected_label }) : null,
      h('span', { class: 'sf-card__label' }, [h('span', { text: o.label }), badge])
    ]);
  }

  function optionList(act, row, s) {
    var pictures = row.options.some(function (o) { return o.img; });
    return h('div', { class: pictures ? 'sf-cards' : 'sf-opts' }, row.options.map(function (o) {
      return pictures ? card(act, row.key, o, s) : pill(act, row.key, o);
    }));
  }

  // Year is a native <select> (the phone's own wheel). With a year it is laid invisibly over
  // the reference layout's folded "1. Year 2020 ^" row; without one (make + model link) it is shown as its
  // bordered "Select Option" dropdown under "1. Year (Select Year)".
  function yearRow(y, s, missingKey) {
    var first = String(s.option_hint || '').replace(/^\(|\)$/g, '');
    var list = y.years.length ? y.years : (y.value ? [y.value] : []);
    var select = h('select', { class: y.value ? 'sf-step__select' : 'sf-select', 'data-sf-year': '', 'aria-label': y.name, 'data-sf-focus': 'year' },
      [h('option', { value: '', text: first, selected: !y.value })].concat(list.map(function (yr) {
        return h('option', { value: yr, text: yr, selected: yr === y.value });
      })));
    var title = h('span', { class: 'sf-step__title', text: y.num + '. ' + y.name });
    var cls = 'sf-step sf-step--year' + (missingKey === 'year' ? ' sf-is-missing' : '');
    if (!y.value) {
      return h('div', { class: cls + ' is-open', 'data-sf-step': 'year' }, [
        h('div', { class: 'sf-step__head sf-step__head--static' }, [title, h('span', { class: 'sf-step__value', text: s.year_hint || s.option_hint })]),
        h('div', { class: 'sf-step__body' }, [h('span', { class: 'sf-select-wrap' }, [select, chevron()])])
      ]);
    }
    return h('div', { class: cls, 'data-sf-step': 'year' }, [
      h('div', { class: 'sf-step__head sf-step__head--select' }, [title, h('span', { class: 'sf-step__value', text: String(y.value) }), chevron(), select])
    ]);
  }

  function stepRow(act, row, s, missingKey) {
    return h('div', { class: stepClass(row, missingKey), 'data-sf-step': row.key }, [
      head(row, s.option_hint),
      h('div', { class: 'sf-step__body' }, [optionList(act, row, s)])
    ]);
  }

  function subRow(sub, s, missingKey) {
    var key = 'seat-' + sub.row;
    return h('div', { class: 'sf-sub' + (missingKey === key ? ' sf-is-missing' : ''), 'data-sf-step': key }, [
      h('p', { class: 'sf-sub__title' }, [h('b', { text: sub.title }), h('span', { class: 'sf-step__value', text: sub.value || s.option_hint })]),
      h('div', { class: 'sf-opts' }, sub.options.map(function (o) {
        return pill('seat', key, o, { 'data-sf-idx': sub.idx });
      }))
    ]);
  }

  function setRow(set, s, missingKey) {
    var body = [h('div', { class: 'sf-cards' }, set.cards.map(function (c) { return card('set', 'set', c, s); }))];
    if (set.rearLink) {
      // The whole "Need Rear Seats Only? Select Rear Seats" line is one button, as in the reference layout. A real
      // space between the two parts, so screen readers and copied text do not read "Only?Select".
      body.push(h('button', { type: 'button', class: 'sf-rear', 'data-sf-act': 'set', 'data-sf-key': 'set', 'data-sf-value': 'rear',
        'data-sf-focus': 'set:set:rear' }, [s.rear_prompt, ' ', h('span', { class: 'sf-link', 'data-sf-value': 'rear', text: s.rear_link_label })]));
    }
    set.subs.forEach(function (sub) { body.push(subRow(sub, s, missingKey)); });
    return h('div', { class: stepClass(set, missingKey), 'data-sf-step': 'set' }, [
      head(set, s.seat_set_hint),
      h('div', { class: 'sf-step__body' }, body)
    ]);
  }

  // Picker buttons carry data-seatfit-open-picker + prefill; seatfit-core.js opens the drawer.
  function message(vm) {
    var b = vm.button || {};
    var attrs = { type: 'button', class: 'sf-msg__btn', text: b.label, 'data-sf-focus': 'msg' };
    if (b.retry) attrs['data-sf-act'] = 'retry';
    if (b.picker) {
      attrs['data-seatfit-open-picker'] = true;
      ['year', 'make', 'model'].forEach(function (k) { if (b.picker[k]) attrs['data-' + k] = b.picker[k]; });
    }
    return h('div', { class: 'sf-msg sf-msg--' + vm.tone, role: vm.tone === 'none' ? null : 'status' }, [
      h('p', { text: vm.text }),
      b.label ? h('button', attrs) : null
    ]);
  }

  function nodes(vm, s) {
    if (vm.kind === 'loading') return [h('div', { class: 'sf-loading', 'aria-hidden': 'true' })];
    if (vm.kind === 'message') return [message(vm)];
    var miss = vm.missing ? vm.missing.key : null;
    var out = [yearRow(vm.year, s, miss)];
    vm.steps.forEach(function (row) { out.push(stepRow('step', row, s, miss)); });
    if (vm.gen) out.push(stepRow('gen', vm.gen, s, miss));
    if (vm.set) out.push(setRow(vm.set, s, miss));
    return out;
  }

  function render(body, vm, s) {
    var active = document.activeElement;
    var focusKey = active && body.contains(active) ? active.getAttribute('data-sf-focus') : null;
    var list = nodes(vm, s);
    body.textContent = '';
    list.forEach(function (n) { body.appendChild(n); });
    if (!focusKey) return;
    var again = body.querySelector('[data-sf-focus="' + focusKey.replace(/["\\]/g, '\\$&') + '"]');
    if (again) again.focus({ preventScroll: true });
  }

  window.SeatFitStepsView = { render: render };
})();
